
const testConfig = (config) => {
  if(!config) {
    throw new Error('Problems with reading from config. Try refreshing the window.');
  }
};
export default testConfig;